import React from 'react';
import getMemberInitials from '../../utils/getMemberInitials';
import Reveal from '../Reveal/Reveal';
import './Profile.scss';

// Component that displays detailed profile information for a single alumni member
// Similar to Profile component but for alumni (no graduation year displayed)
function AProfile(props) {
    // Extract alumni data from props
    const brother = props.Alumni || {};

    const major = Array.isArray(brother.major) ? brother.major[0] : brother.major;
    const experience = Array.isArray(brother.experience) ? brother.experience : [];
    const hasExperience = experience.length > 0;
    const hasInvolvement = Boolean(brother.campusInvolvement && brother.campusInvolvement.trim());
    const hasInterests = Boolean(brother.interestHobbies && brother.interestHobbies.trim());
    const hasFunFact = Boolean(brother.funFact && brother.funFact.trim());
    const hasLinkedin = Boolean(brother.linkedin && brother.linkedin.trim());
    const hasResume = Boolean(brother.resume && brother.resume.trim());
    let fieldIndex = 0;

    return (
        <article className="Profile">
            {/* Left column with image and basic info */}
            <div className="left-col">
                {/* Alumni headshot or chapter-style placeholder */}
                <Reveal as="div" variant="plate" index={0} className="left-col-portrait">
                    {brother.headshot ? (
                        <img src={brother.headshot} alt={brother.name} />
                    ) : (
                        <div
                            className="headshot-placeholder"
                            role="img"
                            aria-label={`${brother.name || 'Alumni'}, no photo`}
                        >
                            <span className="InitialsRing">
                                <span className="Initials">{getMemberInitials(brother.name)}</span>
                            </span>
                        </div>
                    )}
                </Reveal>
                {/* Alumni name */}
                <Reveal as="h1" variant="mask" index={0} id={props.headingId}>{brother.name}</Reveal>
            </div>
            {/* Right column with detailed information */}
            <div className="right-col">
                {/* Initiation class */}
                {brother.class ? (
                    <Reveal as="p" variant="rise" index={fieldIndex++} className="class-title">
                        {brother.class} Class
                    </Reveal>
                ) : null}

                {/* Major information */}
                {major ? (
                    <Reveal as="section" variant="rise" index={fieldIndex++} className="profile-field" aria-label="Major">
                        <h3>Major</h3>
                        <p>{major}</p>
                    </Reveal>
                ) : null}

                {/* Experience section (only shown if experience exists) */}
                {hasExperience && (
                    <Reveal as="section" variant="rise" index={fieldIndex++} className="profile-field" aria-label="Experience">
                        <h3>Experience</h3>
                        {experience.map((exp, index) => (
                            <p key={`${exp.company}-${exp.year}-${index}`}>
                                {exp.year}, {exp.company}, {exp.position}
                            </p>
                        ))}
                    </Reveal>
                )}

                {/* Campus involvement */}
                {hasInvolvement && (
                    <Reveal as="section" variant="rise" index={fieldIndex++} className="profile-field" aria-label="Campus Involvement">
                        <h3>Campus Involvement</h3>
                        <p>{brother.campusInvolvement}</p>
                    </Reveal>
                )}

                {/* Interests and hobbies */}
                {hasInterests && (
                    <Reveal as="section" variant="rise" index={fieldIndex++} className="profile-field" aria-label="Interests and Hobbies">
                        <h3>Interests/Hobbies</h3>
                        <p>{brother.interestHobbies}</p>
                    </Reveal>
                )}

                {/* Fun fact */}
                {hasFunFact && (
                    <Reveal as="section" variant="rise" index={fieldIndex++} className="profile-field" aria-label="Fun Fact">
                        <h3>Fun Fact</h3>
                        <p>{brother.funFact}</p>
                    </Reveal>
                )}

                {/* Action buttons — modal mode omits Close (header owns it) and
                    Back; the row itself is skipped when there's nothing to show. */}
                {(!props.isModal || hasLinkedin || hasResume) && (
                    <Reveal as="div" variant="rise" index={fieldIndex++} className="buttons">
                        {hasLinkedin && (
                            <a
                                className="btn btn--filled"
                                href={brother.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LinkedIn
                            </a>
                        )}
                        {hasResume && (
                            <a
                                className="btn btn--filled"
                                href={brother.resume}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Resume
                            </a>
                        )}
                        {!props.isModal && (
                            <button
                                className="btn btn--outline"
                                type="button"
                                onClick={() => { props.history.push("/alumni"); }}
                            >
                                Back
                            </button>
                        )}
                    </Reveal>
                )}
            </div>
        </article>
    );
};

export default AProfile;
